export const exampleLinks = {
  digitalAssetManagement: `https://acme.lingoapp.com/k/Iconathon-dGp9WX`,
  digitalBrandGuidelines: `https://reddit.lingoapp.com/k/Brand-foundation-oYYL4W`,
  digitalBrandHub: ` https://mediakit.matterport.com/`,
  brandTeams: `https://reddit.lingoapp.com/k/Brand-foundation-oYYL4W`,
  agencies: `https://www.lingoapp.com/102593/k/Nagarro-Brand-Design-Standards-drmg2G`,
};
